import moment from "moment";
import CryptoJS from "crypto-js";

import { store } from "@/configurations";
import { appConfigConstants } from "@/configurations/app-configs/app.config.constants";
import { utilsFunction } from "@/helpers/functions";
import { WS_LANG_KEY } from "@/constants/app";
import { STORAGE_KEY } from "@/constants/storage.key";
import { I_TRADE_ACTION } from "@/constants/i-trade";
import { saveSafeStorage, getInitState } from "@/helpers/global";

const initStateFunc = getInitState({
	FUBONmds: true,
	TTLmds: true,
});
const MDS_ITEM = initStateFunc("TTLmds");

export function createMDSLoginParams() {
	const id = store.getState()?.auth?.aastockClientId || store.getState()?.auth?.user?.external?.dataFeedClientName || store.getState()?.auth?.user?.loginID;
	const companyEntity = appConfigConstants.MDSEntityKey;
	const companySuperkey = appConfigConstants.MDSSuperkey;
	const companyPasswordkey = appConfigConstants.MDSPasswordkey;
	const date = moment().utc().format("YYYYMMDDHHmmssSSS");
	const templateStr = [companyEntity, date, id].join(":");
	const super_key = CryptoJS.enc.Utf8.parse(companySuperkey);
	const dataDecrypted = CryptoJS.AES.encrypt(templateStr, super_key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7,
	});
	const language = utilsFunction.switchToolTipsLanguage(store.getState().app.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC);
	const params = {
		msgType: "LOGIN",
		reqId: 1,
		id,
		data: MDS_ITEM
			? {
				device: "Web",
				Agreement: "N",
				password: MDS_ITEM ? companyPasswordkey || companyEntity : iTradeEnv.company.toUpperCase(),
				language: language,
				entity: companyEntity,
				token: dataDecrypted.ciphertext.toString(CryptoJS.enc.Hex),
			}
			: {
				entity: companyEntity,
				token: dataDecrypted.ciphertext.toString(CryptoJS.enc.Hex),
			},
	};
	return params;
}

export function handleMDSLogin(res) {
	if (res.rtnCode === 0) {
		saveSafeStorage(STORAGE_KEY.MDS_ACCOUNT_TYPE, JSON.stringify(res.service));

		if (res?.agreement.content && params.data.Agreenment !== "Y") {
			store.dispatch({
				type: I_TRADE_ACTION.SET_MDS_AGREEMENT,
				agreement: res.agreement,
			});
		}

		store.dispatch({
			type: I_TRADE_ACTION.SET_MDS_TOKEN,
			mdsToken: res.detail.data,
		});

		store.dispatch({
			type: I_TRADE_ACTION.SET_QUOTE_ACCOUNT,
			mdsAccountType: res.service,
		});
	}
}
